import React from 'react';
import { Grid } from '@mui/material';
import { AutoCompleteSelectUI, DebouncedInputUI, FormLabelUI } from '../Interface';
import useSaveView from '../../hooks/useSaveView';
import useUsers from '../../context/UsersContext';

const TodoFilters = ({ formValState, autoCompleteOptions, prioValue }) => {
  const { formVal, setFormVal } = formValState;
  const { user } = useUsers();
  const saveView = useSaveView(user);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <DebouncedInputUI
          label={<FormLabelUI text="Feladatnév" />}
          debounceMs={800}
          setQuickFilterSearchValue={(newValue) => {
            setFormVal((prevState) => ({
              ...prevState,
              simpleTaskName: newValue,
            }));
          }}
          quickFilterSearchValue={formVal.simpleTaskName}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <AutoCompleteSelectUI
          label={<FormLabelUI text="Státusz" />}
          onChange={(_event, newVal, _reason) => {
            setFormVal((prev) => ({
              ...prev,
              statusId: newVal,
            }));
            saveView('myTodoFilter', { status: newVal });
          }}
          selectedValue={formVal.statusId}
          disabled={false}
          id={'selectedStatus'}
          freeSolo
          isOptionEqualToValue={(option, value) => option.value === value.value}
          multiple
          dataset={autoCompleteOptions.status}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <AutoCompleteSelectUI
          label={<FormLabelUI text="Prioritás" />}
          onChange={(_e, newVal, reason) => {
            if (reason === 'clear') {
              setFormVal((prev) => ({
                ...prev,
                priorId: '',
              }));
              saveView('myTodoFilter', { priority: '' });
            } else {
              setFormVal((prev) => ({
                ...prev,
                priorId: newVal?.value,
              }));
              saveView('myTodoFilter', { priority: newVal });
            }
          }}
          value={prioValue}
          disabled={false}
          id={'selectedPrior'}
          dataset={autoCompleteOptions.priority}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <AutoCompleteSelectUI
          label={<FormLabelUI text="Telephely" />}
          onChange={(_e, newVal, reason) => {
            if (reason === 'clear') {
              setFormVal((prev) => ({
                ...prev,
                companyLocationId: '',
              }));
            } else {
              setFormVal((prev) => ({
                ...prev,
                companyLocationId: newVal?.value,
              }));
            }
          }}
          selectedValue={formVal.companyLocationId}
          disabled={false}
          id={'companyLocationId'}
          dataset={autoCompleteOptions.companyLocation}
        />
      </Grid>
    </Grid>
  );
};

export default TodoFilters;
